"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IGroupBy = void 0;
var IGroupBy;
(function (IGroupBy) {
    IGroupBy["Category"] = "category";
    IGroupBy["Subcategory"] = "subcategory";
    IGroupBy["EntityType"] = "entityType";
})(IGroupBy || (exports.IGroupBy = IGroupBy = {}));
//# sourceMappingURL=group-by.js.map